import { cva } from '@/styled-system/css';

export const popoverHeaderRecipe = cva({
  base: {
    'display': 'flex',
    'alignItems': 'center',
    'gap': 'tighter',
    'flexGrow': 0,
    'flexShrink': 0,
    'flexBasis': 'auto',
    'paddingBlock': 'default',
    'paddingInlineStart': 'layout.tight',
    'paddingInlineEnd': 'layout.looser',
    'borderStartStartRadius': 'obj.default',
    'borderStartEndRadius': 'obj.default',
    'backgroundColor': 'bg.elevated.mediumShadow',

    '& > .c11n_heading': {
      color: 'text.neutral',
      textStyle: 'body-bold',
    },

    '& .c11n_tone-icon': {
      width: 'icon.md',
      height: 'icon.md',
    },
  },
  variants: {
    tone: {
      neutral: {},
      critical: {
        'backgroundColor': 'Popover.Header.bg.critical',
        '& .c11n_tone-icon': {
          color: 'Popover.Header.icon.critical',
        },
      },
      info: {
        'backgroundColor': 'Popover.Header.bg.info',
        '& .c11n_tone-icon': {
          color: 'Popover.Header.icon.info',
        },
      },
      success: {
        'backgroundColor': 'Popover.Header.bg.success',
        '& .c11n_tone-icon': {
          color: 'icon.feedback.success.hero-alt',
        },
      },
      warning: {
        'backgroundColor': 'Popover.Header.bg.warning',
        '& .c11n_tone-icon': {
          color: 'Popover.Header.icon.warning',
        },
      },
    },
  },
});
